export interface PillInputDropdownItem {
  Id: string | number;
  Name: string;
}

export enum PillInputTheme {
  Light = 'pill-input-light',
  Default = 'pill-input',
}
